import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { isCurrentRowTheFooter } from "../utils";
import { getTextWidth } from "common/html-width-helpers";
import { useIsEditMode } from "store/template/designer/selectors";
export const LinkOrLabelCellRenderer = (params) => {
    const isEditMode = useIsEditMode();
    if (isCurrentRowTheFooter(params.node) && params.context.displayTotals && params.value !== undefined) {
        return React.createElement(React.Fragment, null, params.value);
    }
    const colField = params.colDef?.field;
    if (!colField || !(params?.data && (colField in params.data) && params.data[colField])) {
        return React.createElement(React.Fragment, null);
    }
    if (typeof params.data[colField] === "object") {
        if (!("label" in params.data[colField])) {
            return React.createElement(React.Fragment, null, params.data[colField] || "");
        }
    }
    else {
        return React.createElement(React.Fragment, null, params.data[colField] || "");
    }
    const { label } = params.data[colField];
    if (params.data[colField].disabled) {
        return React.createElement(React.Fragment, null, label);
    }
    const textWidth = getTextWidth(label) ?? 100;
    return React.createElement("div", { style: { width: `${textWidth}px` } },
        React.createElement(AuxButton, { type: AuxButtonTypeEnum.TERTIARY, style: {}, href: null, ...params.data[colField], isDisabled: isEditMode }));
};
